import React from 'react';
import classNames from 'classnames';
import { incBase, isIdentityPath, isAccountPath } from '../../../helpers/paths';
import style from './index.module.scss';
import Nav from '.';
import useFeatureFlag from '../../../hooks/use-feature-flag';
import { FeatureFlagName } from '../../../feature-flags';
import { jsx as _jsx } from "react/jsx-runtime";

const Account = _ref => {
  let {
    from = '',
    redirect,
    firstName,
    onClose
  } = _ref;
  // TRADE OFFs note:
  // Ideally since this is a shared component, it should accept this as optional props (eg: showPaymentMethod?: boolean)
  // But in doing so, it would mean there will be other places needs to be updated too which makes
  // activity of removing any online decommission down the track, would require more "thinking"
  const isOnlineDecommissionMode = useFeatureFlag(FeatureFlagName.NEXT_PUBLIC_FEAT_FLAG_ONLINE_DECOMMISSION);
  const path = redirect || "".concat(location.pathname).concat(location.search).concat(location.hash);
  const searchParams = new URLSearchParams({
    path
  });

  if (from !== '') {
    searchParams.append('from', from);
  }

  if (isIdentityPath(path) || isAccountPath(path)) {
    searchParams.set('path', '/');
  }

  const logoutUrl = "".concat(incBase('logout'), "?").concat(searchParams.toString());
  const items = [() => /*#__PURE__*/_jsx("div", {
    className: classNames(style.item, style['item-big']),
    "data-test-id": "main-navdrawer-welcome-message",
    "data-id": "nav_account_items_div",
    children: firstName ? "Hi, ".concat(firstName, "!") : 'Hi!'
  }), {
    label: 'Account',
    url: incBase('account-info', '')
  }, isOnlineDecommissionMode ? undefined : {
    label: 'Orders',
    url: incBase('account-info/orders', 'orders')
  }, isOnlineDecommissionMode ? undefined : {
    label: 'Payment methods',
    url: incBase('account-info/payment-methods', 'payment-methods')
  }, {
    label: 'Sign out',
    url: logoutUrl
  }];
  return /*#__PURE__*/_jsx(Nav, {
    className: classNames(style['nav-reverse']),
    items: items,
    onClose: onClose,
    "data-id": "nav_account_items_Nav"
  });
};

export default Account;